import { postAction, getAction } from './manage'

export function getMessage(address, chainId) {
  return postAction('/api/sessions/message', { address, chainId })
}

export function signIn(signature, ref) {
  const params = { signature }
  if (ref) params.ref = ref
  return postAction('/api/sessions/sign_in', params)
}

export function signOut() {
  return postAction('/api/sessions/sign_out')
}

export function getDirects() {
  return getAction('/api/user/directs')
}

export function getUser() {
  return getAction('/api/user')
}

export function getTeam() {
  return getAction('/api/team')
}

export function getOrders() {
  return getAction('/api/orders')
}

export function redeemOrder(order_id) {
  return postAction('/api/orders/redeem', { order_id })
}

export function syncOrders() {
  return postAction('/api/orders/sync')
}

export function reinvest(order_id) {
  return postAction('/api/reinvest', { order_id })
}

export function submitWithdrawal(amount) {
  return postAction('/api/withdrawal', { amount })
}

export function getSrt() {
  return getAction('/api/srt')
}

export function getLpTiers() {
  return getAction('/api/lp_tiers')
}

export function bindRef(ref_code) {
  return postAction('/api/user/bind_ref', { ref_code })
}

export function getGenesisNodeProfit() {
  return getAction('/api/genesis_node/profit')
}

export function withdrawGenesisNodeProfit(amount) {
  return postAction('/api/genesis_node/withdraw', { amount })
}

export function getBalanceLogs(page = 1) {
  return getAction('/api/user/balance_logs', { page })
}

export function reinvest100() {
  return postAction('/api/withdrawal/reinvest100')
}
